// Shared input-length caps for user-pasted text. Without these the
// frontend would happily POST megabytes to /api/parse-jd or
// /api/b2c/analyze-resume, then the LLM call would timeout or hit the
// Cloudflare Worker CPU budget — earlier passes saw 500s on long JDs.
// Numbers are generous; a senior JD is usually 2-4k chars and a typical
// resume is 5-15k. Anything past these caps is almost certainly noise.

export const MAX_JD_LENGTH = 15000;
export const MAX_RESUME_TEXT_LENGTH = 30000;

// Cap the interview transcript sent to /api/report. A 45-60 min interview is
// usually 15-40k chars; past this the lite model ships malformed/truncated JSON
// and the report route risks the CF Worker CPU budget. We keep the MOST RECENT
// turns (the tail carries the substantive answers) when over the cap.
export const MAX_TRANSCRIPT_LENGTH = 60000;
